import React, { memo } from 'react';
import { ActionButtonProps } from './interfaces';

export const ActionButton = memo<ActionButtonProps>(({
  onClick,
  isActive = false,
  disabled = false,
  variant = 'emerald',
  icon,
  label,
  title,
  hideOnSmall = false,
}) => {
  const getVariantClasses = () => {
    const baseClasses =
      'group min-h-8 px-2.5 rounded-lg transition-all duration-300 flex items-center gap-1.5 font-semibold text-xs whitespace-nowrap border';

    if (disabled) {
      return `${baseClasses} cursor-not-allowed opacity-40 border-transparent bg-transparent text-slate-400`;
    }

    if (isActive) {
      switch (variant) {
        case 'purple':
          return `${baseClasses} border-purple-100 bg-purple-50 text-purple-600 shadow-sm shadow-purple-500/10`;
        case 'blue':
          return `${baseClasses} border-blue-100 bg-blue-50 text-blue-600 shadow-sm shadow-blue-500/10`;
        case 'red':
          return `${baseClasses} border-red-100 bg-red-50 text-red-600 shadow-sm shadow-red-500/10`;
        default:
          return `${baseClasses} border-emerald-100 bg-emerald-50 text-emerald-600 shadow-sm shadow-emerald-500/10`;
      }
    }

    return `${baseClasses} border-slate-200 bg-white text-slate-600 hover:bg-slate-50 active:bg-slate-100`;
  };

  return (
    <button
        onClick={onClick}
        disabled={disabled}
        className={getVariantClasses()}
        title={title}
        aria-label={title}
        aria-pressed={isActive}
    >
      { icon }
      <span className={hideOnSmall ? 'hidden lg:block' : 'hidden md:block'}>
        { label }
      </span>
    </button>
  );
});

ActionButton.displayName = 'ActionButton';
